import axiosInstance from '../common/axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;


const getDiscount = async (id) => {
  const res = await axiosInstance.get(`${backendUrl}/api/discounts/${id}`);
  return res.data;
}; 

const saveDiscount = async (data) => {
  const res = await axiosInstance.post(`${backendUrl}/api/discounts`, data);
  return res.data;
};

export const updateDiscount = async (id, data) => {

  const res = await axiosInstance.put(`${backendUrl}/api/discounts/${id}`, data);
  return res.data;
};

 export const fetchDiscount = async () => {
   
     const res = await axiosInstance.get(`${backendUrl}/api/discounts`);
  return res.data;
  };

 export const deleteDiscount = async (id) => {
   
     const res = await axiosInstance.delete(`${backendUrl}/api/discounts/${id}`);
  return res.data;
  };

export default { getDiscount, saveDiscount, updateDiscount , fetchDiscount,deleteDiscount};